import {
  Authorization,
  AuthorizationResponse,
} from 'src/common/api-clients/github/types'

export const normalizeAuthorizations = (
  authResponse: AuthorizationResponse[],
  chainId: number
) => {
  return authResponse?.reduce<Authorization[]>((acc, auth) => {
    if (auth.hidden) return acc

    const networkKeys = Object.keys(auth.network)
    const networkKey = networkKeys.find(
      key => auth.network[key].chainId === chainId
    )

    return networkKey
      ? [
          ...acc,
          {
            ...auth.network[networkKey],
            name: auth.name,
            isAccountAuthorized: false,
            isSmartAccountAuthorized: false,
            isFullyAuthorized: false,
          },
        ]
      : acc
  }, [])
}
